import { render, staticRenderFns } from "./ATextArea.vue?vue&type=template&id=0976ef32&scoped=true&"
import script from "./ATextArea.vue?vue&type=script&lang=js&"
export * from "./ATextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976ef32",
  null
  
)

export default component.exports